
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sport"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Sport"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id_hr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"img"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"volume_24h"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"change_24h"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"change_24h_pct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total_value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"card_count"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":124}};
    doc.loc.source = {"body":"fragment Sport on Sport {\n  id\n  id_hr\n  name\n  img\n  volume_24h\n  change_24h\n  change_24h_pct\n  total_value\n  card_count\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
